document.addEventListener('DOMContentLoaded', () => {
    let searchBars = document.querySelectorAll('.search-trigger');
    let resultsWrapper = document.querySelector('.predictive-search-container')
    let resultsContainer = resultsWrapper.querySelector('.inner');

    console.log("SEARCH")

    searchBars.forEach(searchBar => {
    
        // Site search using predictive search api
        const predictiveSearchCallBack = () => {
            const section_name = 'v2-predictive-search';

            if(searchBar.value.length > 2){
                
                var requestResponse;
                fetch(`/search/suggest?q=${searchBar.value}&resources[type]=product&section_id=${section_name}`)
                .then((response) => {
                    requestResponse = response;
                    return response.text();
                })
                .then((text) => {
                    if (!requestResponse.ok) {
                        throw new Error(`${requestResponse.status}: ${text}`);
                    }

                    // Results
                    resultsWrapper.classList.add('active');

                    const resultsMarkup = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector(`#shopify-section-${section_name}`).innerHTML;

                    resultsContainer.innerHTML = resultsMarkup;

                    // Results count
                    const searchResults = resultsContainer.querySelectorAll('.product-card'); 
                    const numberOfResults = searchResults.length;
                    const searchTermCount = document.querySelector('.search-term-wrapper .search-count');
                    searchTermCount.innerText = numberOfResults;
                })
                .then(() => {
                    // Term
                    const searchTerm = document.querySelector('.search-term-wrapper .search-term');
                    searchTerm.innerText = searchBar.value;
                })
                .catch((error) => {
                    console.error(error);
                });
            } else {
                resultsContainer.innerHTML = '';
                resultsWrapper.classList.remove('active');
            }
        }
    
        let searchMethod = predictiveSearchCallBack;

        if(searchBar && resultsContainer){
            searchBar.addEventListener('keyup', searchMethod)
            let closeButton = resultsWrapper.querySelector('.close');
            closeButton.addEventListener('click', () => {
                resultsWrapper.classList.remove('active');
            })
        }
    })
    
})